import { render, staticRenderFns } from "./ModuleOnlineOrderFood.vue?vue&type=template&id=231a1933&"
import script from "./ModuleOnlineOrderFood.vue?vue&type=script&lang=js&"
export * from "./ModuleOnlineOrderFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports